import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { MdArrowOutward } from "react-icons/md";
import Checkbox from "../../../Assests/Img/check-box.webp";
import { jobListings } from "../../Data";
const AuditAssociate = () => {
  const form = useRef();
  const [statusMessage, setStatusMessage] = useState("");
  const [isSending, setIsSending] = useState(false);

  const validateForm = () => {
    const formElements = form.current.elements;
    const firstName = formElements["first_name"].value.trim();
    const email = formElements["email_address"].value.trim();
    const phone = formElements["phone_number"].value.trim();
    const position = formElements["position_name"].value;
    const file = formElements["file_name"].files[0];

    if (!firstName) {
      setStatusMessage("Please enter your name.");
      return false;
    }

    // Simple email regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !emailRegex.test(email)) {
      setStatusMessage("Please enter a valid email address.");
      return false;
    }

    // Simple phone regex (10-15 digits)
    const phoneRegex = /^[0-9]{10,15}$/;
    if (!phone || !phoneRegex.test(phone)) {
      setStatusMessage("Please enter a valid phone number (10-15 digits).");
      return false;
    }

    if (!position) {
      setStatusMessage("Please select a position.");
      return false;
    }

    if (file) {
      const allowedTypes = [
        "image/png",
        "image/jpeg",
        "image/jpg",
        "application/pdf",
      ];
      if (!allowedTypes.includes(file.type)) {
        setStatusMessage("Only images or PDFs are allowed.");
        return false;
      }
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSize) {
        setStatusMessage("File size should not exceed 5MB.");
        return false;
      }
    }

    return true;
  };

  const sendApplyEmail = (e) => {
    e.preventDefault();

    if (!validateForm()) return; // Stop if validation fails

    setIsSending(true);
    setStatusMessage("Sending...");

    emailjs
      .sendForm(
        "service_562xl22",
        "template_9b8c1p5",
        form.current,
        "pvZWHrp1z3lcVergQ"
      )
      .then(
        (result) => {
          console.log(result.text);
          setStatusMessage("Email sent successfully!");
          form.current.reset(); // Clear form
        },
        (error) => {
          console.error(error.text);
          setStatusMessage(
            "Failed to send email. Check EmailJS credentials and file size."
          );
        }
      )
      .finally(() => {
        setIsSending(false);
      });
  };
  return (
    <>
      <div className="CareersJobPosition fraunces" id="AuditAssociate">
        {/* banner start */}
        <section id="inner-page-banner">
          <div className="container-fluid bgimg">
            <div className="row">
              <h1 className="main-head">Audit Associate</h1>
            </div>
          </div>
        </section>
        {/*banner end */}
        {/* ================= */}
        {/* Designation start */}
        <div id="designation" className="mobile-spacing tablet-spacing">
          <div className="container-fluid p-xs-0 padding-md-0">
            <p className="text-desc">
              <span>Position:</span>Audit Associate
            </p>
            <p className="text-desc">
              <span>Employment Type:</span>Permanent, Full-time or Part-time
            </p>
          </div>
        </div>
        <div className="container-fluid">
          <div className="divider"></div>
        </div>
        {/* Designation end */}
        {/* =================== */}
        {/* job-overview start */}
        <section id="job-overview" className="mobile-spacing tablet-spacing">
          <div className="container-fluid p-xs-0 padding-md-0">
            <h2 className="main-head">Role Summary</h2>
            <p className="text-desc">
              At Chawla and Associates CPAs, our Audit Associates play a key
              role in delivering high-quality audit services while maintaining
              the highest standards of integrity, objectivity, and professional
              skepticism. This role involves executing audit procedures,
              preparing financial documentation, and collaborating with team
              members to ensure compliance with accounting and auditing
              standards.
            </p>
          </div>
        </section>
        {/* job-overview end */}
        {/* ===================== */}
        {/* responsibilities-and-experience start */}
        <div
          id="responsibilities-and-experience"
          className="bgimg mobile-spacing tablet-spacing"
        >
          <div className="container-fluid inner">
            <div className="row">
              <div className="col-lg-6 col-md-12 p-xs-0 padding-md-0">
                <div className="responsibilities">
                  <h2 className="main-head">Responsibilities</h2>
                  <div className="icon-list">
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        Conduct audit procedures to obtain sufficient and
                        appropriate audit evidence in accordance with applicable
                        auditing standards.
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        Maintain professional skepticism and exercise sound
                        judgment in assessing financial statements and internal
                        controls.
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        Assist in preparing audit documentation, including
                        financial reports, workpapers, and findings.
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        {" "}
                        Identify and document audit misstatements, evaluating
                        their impact on materiality.
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        Coordinate with internal and external specialists and
                        assess the impact of findings on audit engagements.
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        Collaborate with senior auditors and partners to ensure
                        timely completion of audit engagements.
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        Ensure compliance with GAAP, GAAS, and other relevant
                        accounting and auditing frameworks.
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        Communicate effectively with clients, gathering
                        necessary information and responding to queries.
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        Assist in the planning phase of engagements, including
                        client communications, resource allocation, and audit
                        execution planning.
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        Support team members by providing guidance, coaching,
                        and training as needed.
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        Maintain confidentiality and uphold the ethical
                        standards of the accounting profession.
                      </p>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 p-xs-0 padding-md-0">
                <div className="experience">
                  <h2 className="main-head">
                    Qualifications, Skills, and Knowledge
                  </h2>
                  <div className="icon-list">
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        Bachelor’s degree in Accounting, Finance, or a related
                        field (CPA or CPA candidate preferred).
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        Proficiency in MS Office and accounting software.
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        {" "}
                        Strong analytical and problem-solving skills.
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        Excellent communication skills, both written and verbal.
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        {" "}
                        Detail-oriented with strong organizational skills.
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        Ability to work independently and collaboratively in a
                        fast-paced environment.
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        {" "}
                        Prior audit experience (2+ years preferred), especially
                        in public accounting.
                      </p>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* responsibilities-and-experience end */}
        {/* ======================= */}
        {/* why-join start */}
        <div id="why-join" className="mobile-spacing tablet-spacing">
          <div className="container-fluid p-xs-0 padding-md-0">
            <h2 className="main-head">Why Join Chawla and Associates CPAs?</h2>
            <div className="icon-list">
              <span>
                <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                <p className="text-desc">
                  Collaborative and growth-oriented work environment.
                </p>
              </span>
              <span>
                <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                <p className="text-desc">
                  Opportunities for professional development and advancement.
                </p>
              </span>
              <span>
                <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                <p className="text-desc">
                  Competitive compensation and benefits package.
                </p>
              </span>
              <span>
                <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                <p className="text-desc">
                  Exposure to diverse industries and clients.
                </p>
              </span>
            </div>
          </div>
        </div>
        {/* why-join end */}
        {/* ===================== */}
        {/* cta start */}
        <div id="cta" className="bgimg mobile-spacing tablet-spacing">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-8 p-xs-0">
                <h2 className="main-head">How to Apply</h2>
                <p className="text-desc">
                  We’d love to hear from you. Please send your application to{" "}
                  <a href="mailto:info@chawlacpa.com">info@chawlacpa.com</a>,
                  and make sure to include the position title in the subject
                  line so we can review it quickly and connect you with the
                  right person.
                </p>
              </div>
              <div className="col-md-4 btns p-xs-0">
                <a>
                  <button
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#myModal"
                    className="bg-remove-btn-svg"
                  >
                    Apply Now
                    <span>
                      <MdArrowOutward />
                    </span>
                  </button>
                </a>
                {/* Modal */}
                <div className="modal fade" id="myModal">
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-body">
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                        ></button>
                        <div className="modal-body-content">
                          <h2 className="main-head"> We're Hiring </h2>
                          <form ref={form}>
                            <input
                              type="text"
                              name="first_name"
                              placeholder="Enter Name"
                              required
                            />
                            <input
                              type="email"
                              name="email_address"
                              placeholder="Enter Email"
                              required
                            />
                            <input
                              type="tel"
                              name="phone_number"
                              placeholder="Enter Phone No."
                              required
                            />
                            <select name="position_name" id="position" required>
                              {jobListings.map((job, idx) => (
                                <option key={idx} value={job.title}>
                                  {job.title}
                                </option>
                              ))}
                            </select>
                            <input
                              type="file"
                              name="file_name"
                              accept="image/*,application/pdf"
                            />

                            <a
                              href="#"
                              className="common-btn"
                              onClick={sendApplyEmail}
                              style={{
                                pointerEvents: isSending ? "none" : "auto",
                              }}
                            >
                              Submit
                            </a>

                            {statusMessage && (
                              <p
                                className={
                                  statusMessage.includes("successfully")
                                    ? "status-success"
                                    : "status-error"
                                }
                              >
                                {statusMessage}
                              </p>
                            )}
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* cta end */}
      </div>
    </>
  );
};

export default AuditAssociate;
